import styled from "styled-components";

import { NotificationListStyledProps as Props } from "./NotificationList.types";
import CONSTANTS from "config/constants";

const { desktop } = CONSTANTS.BREAKPOINTS;

const NotificationListStyled = styled.div<Props>`
  .NotificationList {
    &__date {
      display: inline-block;
      padding: 0.4rem 1.6rem;
      margin-top: 3.2rem;
      background-color: var(--palette-gray-s0-l98);
      color: var(--palette-black-s0-l4);
      border-radius: 0.4rem;
    }

    &__notification {
      padding: 2.8rem 0;
      border-bottom: 0.1rem solid var(--palette-gray-s0-l25);
    }

    &__placeholder {
      &__date {
        position: relative;
        display: inline-block;
        width: 7.2rem;
        height: 2.2rem;
        margin-top: 3.2rem;
        background-color: var(--palette-gray-s0-l95);
        border-radius: 0.4rem;
        overflow: hidden;
      }

      &__notification {
        padding: 2.8rem 0;
        border-bottom: 0.1rem solid var(--palette-gray-s0-l95);
      }
    }

    &__error-block {
      margin-top: 4rem;
    }

    &__empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      margin: 7.6rem 0;
      text-align: center;

      &__title {
        color: var(--palette-white);
        font-size: 2.6rem;
        padding-bottom: 1.2rem;
        padding-top: 1.2rem;
        line-height: 3.2rem;
        font-weight: 700;
      }

      &__description {
        color: var(--palette-gray-s0-l80);
        font-size: 1.6rem;
        line-height: 2.2rem;
        font-weight: 400;

        @media (min-width: ${desktop}px) {
          max-width: 26.4rem;
          font-size: 1.6rem;
          line-height: 2.4rem;
        }
      }

      &__icon {
        background-color: var(--palette-black-s0-l10);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-block: 2.8rem;
        padding-inline: 2.8rem;
      }
    }
  }
`;

export default NotificationListStyled;
